/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DiscussionAnswerDto } from '../models/DiscussionAnswerDto';
import type { FormAnswerUpdatedDto } from '../models/FormAnswerUpdatedDto';
import type { FormResponseAnswer } from '../models/FormResponseAnswer';
import type { FormResponseAnswerDto } from '../models/FormResponseAnswerDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FormResponseAnswerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get an answer to a form element.
     * @param formGuid The form's guid - included to show in logs
     * @param responseGuid The response's guid.
     * @param formElementGuid The form element to get the answer of.
     * @param repeatableGroupGuid The repeatable group guid.
     * @returns FormResponseAnswer OK
     * @throws ApiError
     */
    public getAnswer(
        formGuid: string,
        responseGuid: string,
        formElementGuid: string,
        repeatableGroupGuid: string,
    ): CancelablePromise<FormResponseAnswer> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/mwforms/{formGuid}/responses/{responseGuid}/answers/{formElementGuid}/{repeatableGroupGuid}/GetAnswer',
            path: {
                'formGuid': formGuid,
                'responseGuid': responseGuid,
                'formElementGuid': formElementGuid,
                'repeatableGroupGuid': repeatableGroupGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete an answer to a form element.
     * @param formGuid The form's guid.
     * @param responseGuid The response's guid.
     * @param formElementGuid The form element to
     * answer.
     * @param repeatableGroupGuid
     * @returns FormResponseAnswer OK
     * @throws ApiError
     */
    public deleteAnswer(
        formGuid: string,
        responseGuid: string,
        formElementGuid: string,
        repeatableGroupGuid: string,
    ): CancelablePromise<Array<FormResponseAnswer>> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/mwforms/{formGuid}/responses/{responseGuid}/answers/{formElementGuid}/{repeatableGroupGuid}/DeleteAnswer',
            path: {
                'formGuid': formGuid,
                'responseGuid': responseGuid,
                'formElementGuid': formElementGuid,
                'repeatableGroupGuid': repeatableGroupGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete an answer to a form element.
     * @param formGuid The form's guid.
     * @param responseGuid The response's guid.
     * @param repeaterHostElementGuid The form element to
     * answer.
     * @param repeatableGroupGuid
     * @param requestBody
     * @returns FormResponseAnswer OK
     * @throws ApiError
     */
    public deleteRepeaterAnswer(
        formGuid: string,
        responseGuid: string,
        repeaterHostElementGuid: string,
        repeatableGroupGuid: string,
        requestBody?: string,
    ): CancelablePromise<Array<FormResponseAnswer>> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/mwforms/{formGuid}/responses/{responseGuid}/answers/{repeaterHostElementGuid}/{repeatableGroupGuid}/DeleteRepeaterAnswer',
            path: {
                'formGuid': formGuid,
                'responseGuid': responseGuid,
                'repeaterHostElementGuid': repeaterHostElementGuid,
                'repeatableGroupGuid': repeatableGroupGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get the answer of a particular question code in a form response.
     * @param responseGuid The response's guid.
     * @param formGuid
     * @param requestBody The answer's question code.
     * @returns FormResponseAnswerDto OK
     * @throws ApiError
     */
    public getAnswersFromCodes(
        responseGuid: string,
        formGuid: string,
        requestBody?: Array<string>,
    ): CancelablePromise<Array<FormResponseAnswerDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/mwforms/{formGuid}/responses/{responseGuid}/answers/GetAnswersFromCodes',
            path: {
                'responseGuid': responseGuid,
                'formGuid': formGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Used to create a new repeater item inside a repeater host. If a repeater host doesn't exist, it will create
     * one with as many repeats specified.
     * @param formGuid
     * @param responseGuid The response's guid.
     * @param formElementGuid
     * @param orgGuid
     * @param requestBody
     * @returns FormResponseAnswer OK
     * @throws ApiError
     */
    public createRepeaterAnswer(
        formGuid: string,
        responseGuid: string,
        formElementGuid: string,
        orgGuid?: string,
        requestBody?: number,
    ): CancelablePromise<Array<FormResponseAnswer>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/mwforms/{formGuid}/responses/{responseGuid}/answers/{formElementGuid}/CreateRepeaterAnswer',
            path: {
                'formGuid': formGuid,
                'responseGuid': responseGuid,
                'formElementGuid': formElementGuid,
            },
            query: {
                'orgGuid': orgGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Submit an answer to form element. Will create a new answer if it does not exist, or update if it
     * does.
     * @param responseGuid The response's guid.
     * @param formElementGuid The form element to
     * answer.
     * @param repeatableGroupGuid
     * @param questionCode The QuestionCode, if available. We don't use it... this is for nicer logging.
     * @param formGuid
     * @param requestBody The new answer to the form element.
     * @returns FormResponseAnswer OK
     * @throws ApiError
     */
    public submitAnswer(
        responseGuid: string,
        formElementGuid: string,
        repeatableGroupGuid: string,
        questionCode: string,
        formGuid: string,
        requestBody?: any,
    ): CancelablePromise<Array<FormResponseAnswer>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/mwforms/{formGuid}/responses/{responseGuid}/answers/{formElementGuid}/{repeatableGroupGuid}/SubmitAnswer-{_questionCode}',
            path: {
                'responseGuid': responseGuid,
                'formElementGuid': formElementGuid,
                'repeatableGroupGuid': repeatableGroupGuid,
                '_questionCode': questionCode,
                'formGuid': formGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * This method is used to submit a discussion answer to a form element.
     *
     * The commentDto should contain the comment text and the ID of the comment being replied to. It will
     * also contain the ID of the comment itself.
     *
     * If the replyTo ID is 0, it will add the comment as a new comment to the discussion.
     * If the replyTo ID is not 0, it will add the comment as a reply to the comment with the given ID.
     * If the replyTo ID === the comment ID, it will edit the comment with the given ID, replacing the text.
     * @param responseGuid The response's guid.
     * @param formElementGuid The form element to
     * answer.
     * @param repeatableGroupGuid
     * @param formGuid
     * @param requestBody The new comment in the discussion.
     * @returns FormResponseAnswer OK
     * @throws ApiError
     */
    public submitDiscussionAnswer(
        responseGuid: string,
        formElementGuid: string,
        repeatableGroupGuid: string,
        formGuid: string,
        requestBody?: DiscussionAnswerDto,
    ): CancelablePromise<Array<FormResponseAnswer>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/mwforms/{formGuid}/responses/{responseGuid}/answers/{formElementGuid}/{repeatableGroupGuid}/SubmitDiscussionAnswer',
            path: {
                'responseGuid': responseGuid,
                'formElementGuid': formElementGuid,
                'repeatableGroupGuid': repeatableGroupGuid,
                'formGuid': formGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get the schema for FormAnswerUpdated SignalR messages.
     * This endpoint exists solely for Swagger documentation of the SignalR message format.
     * @param formGuid
     * @param responseGuid
     * @returns FormAnswerUpdatedDto OK
     * @throws ApiError
     */
    public getApiMwformsResponsesAnswersSignalrSchemaFormAnswerUpdated(
        formGuid: string,
        responseGuid: string,
    ): CancelablePromise<FormAnswerUpdatedDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/mwforms/{formGuid}/responses/{responseGuid}/answers/signalr-schema/form-answer-updated',
            path: {
                'formGuid': formGuid,
                'responseGuid': responseGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
